<template>
    <div class="module">
        <header class="module__header">
            <a
                class="back-btn"
                @click="goBack('super-firmware')"
            >
                <span class="icon-chevron-left" />
            </a>
            <h1 class="has-back-btn">Upload Firmware</h1>
        </header>

        <section class="module__body">
            <form @submit.prevent="update">
                <div class="form-group">
                    <label>Version</label>
                    <span data-test-id="version">{{ version }}</span>
                </div>

                <div class="form-group">
                    <label for="protocol">Protocol</label>
                    <select
                        id="protocol"
                        v-model="protocol"
                        required
                    >
                        <option value="ag1.0">ag1.0</option>
                        <option value="ag1.1">ag1.1</option>
                        <option value="ag1.2">ag1.2</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="release_date">Release Date</label>
                    <input
                        id="release_date"
                        v-model="release_date"
                        type="date"
                        required
                    />
                </div>

                <div class="form-group">
                    <label for="description">Description</label>
                    <textarea
                        id="description"
                        v-model="description"
                        required
                    />
                </div>

                <div class="form-group">
                    <label>Premium Capable</label>
                    <span data-test-id="is_premium_value">{{ $filters.convertBoolean(is_premium) }}</span>
                </div>

                <form-errors :response="errorResponse"></form-errors>

                <div class="form-group">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        <div>Update</div>
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'
import hasBackButton from '@/mixins/hasBackButton'

export default {
    components: {
        FormErrors,
    },

    mixins: [canToast, hasBackButton],

    data() {
        return {
            id: this.$route.params.id,
            filenames: {},
            protocol: 'ag1.0',
            release_date: null,
            description: null,
            is_premium: null,
            version: null,
            errorResponse: null,
        }
    },

    mounted() {
        this.$http.get(`firmware/${this.id}`).then(({ data }) => {
            this.protocol = data.protocol
            this.release_date = data.release_date
            this.description = data.description
            this.is_premium = data.is_premium
            this.version = data.version
        })
    },

    methods: {
        update() {
            this.$http
                .put(`firmware/${this.id}`, {
                    protocol: this.protocol,
                    release_date: this.release_date,
                    description: this.description,
                })
                .then(() => {
                    this.toast('Firmware update successfully updated!')
                    this.$router.push('/firmware')
                })
                .catch((error) => {
                    this.errorResponse = error.response
                })
        },
    },
}
</script>
